import actions from './actions'

const initialState = {
  userAccDetails: {},
}

export default function accReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_ACCDETAILS:
      return { ...state, userAccDetails: action.payload }

    default:
      return state
  }
}
